// layouts/catalogos/parametros/services/parametros.js
import api from "services/api";

// Ajusta el endpoint si tu backend usa otro nombre
const BASE = "/awardParam"; // <-- si tu API usa "/param", cámbialo aquí

const unwrapRows = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.rows)) return data.rows;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.page)) return data.page;
  if (Array.isArray(data?.results)) return data.results;
  return [];
};

export async function listParametros(params = {}) {
  const { data } = await api.get(BASE, { params });

  const rows = unwrapRows(data);
  const total =
    data?.total ??
    data?.count ??
    data?.totalCount ??
    (typeof data?.pagination?.total === "number"
      ? data.pagination.total
      : rows.length);

  return { rows, total };
}

export async function getParametro(id) {
  const { data } = await api.get(`${BASE}/${id}`);
  return data?.data ?? data;
}

export async function createParametro(payload) {
  const { data } = await api.post(BASE, payload);
  return data?.data ?? data;
}

export async function updateParametro(id, payload) {
  const { data } = await api.put(`${BASE}/${id}`, payload);
  return data?.data ?? data;
}

export async function deleteParametro(id) {
  const { data } = await api.delete(`${BASE}/${id}`);
  return data?.data ?? data;
}
